<template>
  <div class="loading-wrap" v-if="isShowLoading">
    <img src="@img/third_login_loading.gif" alt="加载中" />
  </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui'
import loginService from '@svc/login'
import { jump } from '@util/function'
import setDocumentTitle from '@util/document-title'
import account from '@lib/account'

export default {
  data() {
    return {
      isShowLoading: true,
    }
  },
  mounted() {
    setDocumentTitle('联名登录')
    let { appId, data } = this.$route.query
    data = decodeURIComponent(data)
    // 校验数据
    if (!appId || !data) {
      return this.toErrorPage()
    }
    this.requestJointLogin(appId, data)
  },
  methods: {
    async requestJointLogin(appId, data) {
      try {
        const res = await loginService.jointLogin({ appId, data })
        const { isRegistered, mallInfo } = res
        if (isRegistered) {
          // 保存登录信息，跳转首页
          account.setLoginSuccessData(res)
          this.redirectUri = this.getRedirectUri(mallInfo.mallCode)
          jump({ url: this.redirectUri })
        } else {
          // 未绑定手机号
          this.$router.replace({
            name: 'bindPhone',
            query: {
              loginToken: res.loginToken,
            },
          })
        }
      } catch (e) {
        console.error(e)
        // 联名登录未开启等异常处理
        MessageBox({
          title: '提示',
          message: e.msg,
          showCancelButton: false,
        }).then((action) => {
          if (action != 'cancel') {
            this.toErrorPage()
          }
        })
      }
    },
    toErrorPage() {
      this.$router.push({
        name: 'tips',
      })
    },
    showToast(msg) {
      if (!msg) {
        return
      }
      Toast({
        message: msg,
        position: 'bottom',
        duration: 3000,
      })
    },
    getRedirectUri(code) {
      return process.env.VUE_APP_KAOP_MALL_HOST + '/ka/' + code
    },
  },
}
</script>

<style lang="less">
.loading-wrap {
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 560px;
  height: 420px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
